import { type ReactNode } from 'react'
import { TabPanel } from '@headlessui/react'

interface PageTabPanelProps extends Record<string, unknown> {
  className?: string
}

export const PageTabPanel = ({ className, ...props }: PageTabPanelProps): ReactNode => {
  return (
    <div className={className}>
      <TabPanel {...props} />
    </div>
  )
}
